/**
 * Image Banner - Mobile Scroll Animation
 * 
 * Triggers the same animation that occurs on desktop hover when the
 * section scrolls into view on mobile devices. Uses Intersection Observer
 * API for efficient scroll detection.
 */

class ImageBannerScrollAnimation {
  constructor() {
    this.init();
  }

  init() {
    // Only initialize on mobile
    if (window.innerWidth >= 750) {
      return;
    }

    this.observeImageBanners();
    
    // Re-observe on window resize in case device orientation changes
    window.addEventListener('resize', () => {
      if (window.innerWidth < 750) {
        this.observeImageBanners();
      }
    });
  }

  observeImageBanners() {
    // Find all image banner sections with two-image layout
    const banners = document.querySelectorAll('.banner--two-images');

    if (banners.length === 0) {
      return;
    }

    // Intersection Observer options
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // Trigger when 50% of the section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Section is at least 50% visible - activate animation
          entry.target.classList.add('banner--scroll-active');
        } else {
          // Section is less than 50% visible - deactivate animation
          entry.target.classList.remove('banner--scroll-active');
        }
      });
    }, observerOptions);

    // Observe each banner
    banners.forEach((banner) => {
      observer.observe(banner);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ImageBannerScrollAnimation();
  });
} else {
  new ImageBannerScrollAnimation();
}
